<div class="input-wrapper collapsed" #expandable>
    <div class="template-container">
        <div class="input-header">
            <div class="title">
                From Templates
            </div>
        </div>
        <div class="template-picker">
            <div class="template">
                Stuff goes here
            </div>
        </div>
    </div>
    <div class="input-container">
        <kve-input-header [title]="title" (onClose)="close($event)"></kve-input-header>
        <div class="input-cell">
            <nb-actions>
                <nb-action>
                    <nb-icon [icon]="collapsed ? 'arrowhead-left-outline' : 'arrowhead-right-outline'"
                        pack="eva" pack="eva" (click)="toggleContainer()">
                    </nb-icon>
                </nb-action>
                <nb-action>
                    Templates
                </nb-action>
            </nb-actions>
        </div>
        <div class="input-cell">
            <div class="description">1 cell over 1 row</div>
            <div class="graphic cell-3" (click)="createGrid(1)">
                <svg width="140px" height="60px" xmlns="http://www.w3.org/2000/svg">
                    <!-- First Rectangle -->
                    <rect class="grid-option-rec" x="0" y="0" width="138px" height="60px" fill="none" stroke="white" stroke-width="1"/>
                </svg>
            </div>
        </div>
        <div class="input-cell">
            <div class="description">Two cells over 1 row</div>
            <div class="graphic cell-3" (click)="createGrid(2)">
                <svg width="140px" height="60px" xmlns="http://www.w3.org/2000/svg">
                    <!-- First Rectangle -->
                    <rect class="grid-option-rec" x="0" y="0" width="67px" height="60px" fill="none" stroke="white" stroke-width="1"/>
                    
                    <!-- Second Rectangle -->
                    <rect class="grid-option-rec" x="73px" y="0" width="67px" height="60px" fill="none" stroke="white" stroke-width="1"/>
                </svg>
            </div>
        </div>
        <div class="input-cell">
            <div class="description">Three cells over 1 row</div>
            <div class="graphic cell-4" (click)="createGrid(3)">
                <svg width="140px" height="60px" xmlns="http://www.w3.org/2000/svg">
                    <!-- First Rectangle -->
                    <rect class="grid-option-rec" x="0" y="0" width="40px" height="60px" fill="none" stroke="white" stroke-width="1"/>
                    
                    <!-- Second Rectangle -->
                    <rect class="grid-option-rec" x="50px" y="0" width="40px" height="60px" fill="none" stroke="white" stroke-width="1"/>
                    
                    <!-- Third Rectangle -->
                    <rect class="grid-option-rec" x="98px" y="0" width="40px" height="60px" fill="none" stroke="white" stroke-width="1"/>
                  </svg>
                 
            </div>
        </div>
        <div class="input-cell">
            <div class="description">Five Cells over 2 rows</div>
            <div class="graphic cell-5" (click)="createGrid(4)">
                <svg width="140px" height="60px" xmlns="http://www.w3.org/2000/svg">
                    <!-- First Rectangle -->
                    <rect class="grid-option-rec" x="0" y="0" width="31px" height="60px" fill="none" stroke="white" stroke-width="1"/>
                    
                    <!-- Second Rectangle -->
                    <rect class="grid-option-rec" x="35px" y="0" width="31px" height="60px" fill="none" stroke="white" stroke-width="1"/>
                    
                    <!-- Third Rectangle -->
                    <rect class="grid-option-rec" x="72px" y="0" width="31px" height="60px" fill="none" stroke="white" stroke-width="1"/>
                    
                    <!-- Fourth Rectangle -->
                    <rect class="grid-option-rec" x="109px" y="0" width="31px" height="60px" fill="none" stroke="white" stroke-width="1"/>
                  </svg>
                  
            </div>
        </div>        
    </div>
</div>
